import { render, staticRenderFns } from "./MiniAvatar.vue?vue&type=template&id=7f9c9a51"
import script from "./MiniAvatar.vue?vue&type=script&lang=ts"
export * from "./MiniAvatar.vue?vue&type=script&lang=ts"
import style0 from "./MiniAvatar.vue?vue&type=style&index=0&id=7f9c9a51&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports